import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelDeleteAccount} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


class DeleteAccountFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(_values) {
    return this.props.deleteAccount({accountId: this.props.accountId, customerId: this.props.customerId})
      .then((response) => {
        if (response.data.deleteAccount.errors.length <= 0) {
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.deleteAccount.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelDeleteAccount();
  }

  render() {
    return (
      <Form
        message="This will delete the account unless the customer has no other or there are unresolved issues."
        submitLabel="Delete Account"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        errors={this.state.errors}
        />
    )
  }
}

const DELETE_ACCOUNT = gql`
  mutation deleteAccount($data: DeleteAccountInput!) {
    deleteAccount(input: $data) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(DELETE_ACCOUNT, {
    props: ({ mutate }) => ({
      deleteAccount: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelDeleteAccount})(withQueries(DeleteAccountFormContainer));